import React from 'react';
import SocketRedux from './redux';

interface Props {
  children?: React.ReactNode;
}

const SocketProvider: React.FC<Props> = ({ children }) => {
  const SocketReducer = SocketRedux.useReducer();
  return (
    <SocketRedux.Context.Provider
      value={{ state: SocketReducer.state, dispatch: SocketReducer.dispatch }}>
      {children}
    </SocketRedux.Context.Provider>
  );
};

export default SocketProvider;
